import { cn } from "../lib/utils";

const STATUS_COLORS = {
  Open: "bg-blue-50 text-blue-700 border-blue-200",
  Closed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "To Start": "bg-violet-50 text-violet-700 border-violet-200",
  "Offer Declined": "bg-red-50 text-red-700 border-red-200",
  "On Hold": "bg-amber-50 text-amber-700 border-amber-200",
  "Closed-Resigned": "bg-slate-100 text-slate-700 border-slate-200",
  Cancelled: "bg-rose-50 text-rose-700 border-rose-200",
};

const PRIORITY_COLORS = {
  High: "bg-red-50 text-red-700 border-red-200",
  Medium: "bg-amber-50 text-amber-700 border-amber-200",
  Low: "bg-slate-50 text-slate-600 border-slate-200",
};

export function StatusBadge({ status, className }) {
  const c = STATUS_COLORS[status] || "bg-muted text-foreground border-border";
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s/g, "-")}`}
      className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-medium whitespace-nowrap", c, className)}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70 mr-1.5" />
      {status}
    </span>
  );
}

export function PriorityBadge({ priority, className }) {
  const c = PRIORITY_COLORS[priority] || "bg-muted text-foreground border-border";
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium border", c, className)}>
      {priority}
    </span>
  );
}
